import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { FShift, ShiftBreak } from "../../../../../../types/types";
import { useFetch } from "../../../../../../hooks/useFetch";
import _ from "lodash";
import { ColumnDef } from "@tanstack/react-table";
import { ShiftBreaksTabTableData } from "../../../../../../types/formDataTypes";
import { DataTable } from "../../../../../../ui/DataTable/DataTable";
import { Separator } from "../../../../../../ui/Separator";
import { DateTime } from "luxon";
import AddBreak from "./addBreak";
import EditBreak from "./editBreak";

type Props = {
  id: string | undefined;
  currentShift: FShift | undefined;
};

const ShiftBreaks = ({ id, currentShift }: Props) => {
  const [breaks, setBreaks] = useState<ShiftBreak[]>();

  let [isEditOpen, setIsEditOpen] = useState(false);
  let [currentItemId, setCurrentItemId] = useState("");

  function openEditModal() {
    setIsEditOpen(true);
  }

  function closeEditModal() {
    setIsEditOpen(false);
    setCurrentItemId("");
  }

  const onItemEdit = (id: string) => {
    setCurrentItemId(id);
    openEditModal();
  };

  const [{ response, isLoading, error }, doFetchItem] = useFetch(
    `/directories/working_shifts/${id}/working_shift_breaks`
  );

  const refreshModels = () => {
    doFetchItem();
  };

  useEffect(() => {
    refreshModels();
  }, []);

  useEffect(() => {
    if (response) {
      const modelsData = response.data as unknown as ShiftBreak[];
      setBreaks(modelsData);
    }
  }, [response]);

  let nodes = breaks?.map((data) => {
    return {
      id: data?.id,
      started_at: data.attributes.started_at,
      ended_at: data.attributes.ended_at,
    };
  });

  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  const columns: ColumnDef<ShiftBreaksTabTableData>[] = [
    {
      header: t("started_at"),
      cell: ({ row }) => <div>{DateTime.fromISO(row.original.started_at).toFormat("HH:mm")}</div>,
    },
    {
      header: t("ended_at"),
      cell: ({ row }) => <div>{DateTime.fromISO(row.original.ended_at).toFormat("HH:mm")}</div>,
    },
  ];

  return (
    <div className="flex flex-col w-full gap-8">
      {currentItemId != "" && (
        <EditBreak
          id={currentItemId}
          shiftId={id}
          isEditOpen={isEditOpen}
          closeModal={closeEditModal}
          refreshModels={refreshModels}
          shiftBreaks={breaks}
          currentShift={currentShift!}
        />
      )}
      <AddBreak itemId={id} refreshModels={refreshModels} currentShift={currentShift!} />
      <div className="flex flex-col gap-2">
        <div className="text-base font-medium">{t("breaks_shift_text")}</div>
        <Separator className="flex-none" />
        <DataTable data={data.nodes} columns={columns} onClickRow={onItemEdit} />
      </div>
    </div>
  );
};

export default ShiftBreaks;
